<template>
  <ConfigurableDashboard dashboard-key="procurement" permission-key="ProcurementDashboard" :default-widgets="['stockValue']" />
</template>
<script>
import ConfigurableDashboard from "../../components/ConfigurableDashboard.vue";

export default {
  name: "ProcurementDashboard",
  components: { ConfigurableDashboard },
};
</script>
